import { useState, useEffect } from 'react';
import { Heart } from 'lucide-react';
import { toast } from 'react-toastify';

interface NameLikeButtonProps {
  name: string;
}

export default function NameLikeButton({ name }: NameLikeButtonProps) {
  const [isLiked, setIsLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(0);

  useEffect(() => {
    const likes = JSON.parse(localStorage.getItem('nameLikes') || '{}');
    setIsLiked(!!likes[name]);
    setLikeCount(likes[name]?.count || 0);
  }, [name]);

  const handleLike = () => {
    const likes = JSON.parse(localStorage.getItem('nameLikes') || '{}');
    
    if (likes[name]) {
      delete likes[name];
      setIsLiked(false);
      setLikeCount(prev => prev - 1);
      toast.info('Removed from favorites');
    } else {
      likes[name] = { timestamp: Date.now(), count: (likes[name]?.count || 0) + 1 };
      setIsLiked(true);
      setLikeCount(prev => prev + 1);
      toast.success('Added to favorites');
    }
    
    localStorage.setItem('nameLikes', JSON.stringify(likes));
  };

  return (
    <button
      onClick={handleLike}
      className={`flex items-center gap-2 px-3 py-1.5 rounded-full transition-colors ${
        isLiked
          ? 'bg-pink-100 text-pink-600'
          : 'bg-gray-100 text-gray-600 hover:bg-pink-50 hover:text-pink-600'
      }`}
    >
      <Heart
        size={16}
        className={isLiked ? 'fill-current' : ''}
      />
      <span className="text-sm font-medium">{likeCount}</span>
    </button>
  );
}